export default "__VITE_ASSET__63a399e3__"